module.exports = __webpack_public_path__ + "fonts/Cairo-SemiBold.6ce3572.woff2";